// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Z2-z","dimensionLabel":"_2-z","styleChooserControlWrapper":"a3-z","styleChooserControl":"b3-z","disabled":"c3-z","giftCard":"d3-z","styleChooserText":"e3-z"};